import React from "react";
import { t } from "ttag";

import { MasonryGrid } from "../../../common/MasonryGrid";
import { IProduct } from "../../../models/catalogue";
import { useAppSelector } from "../../reducers";
import { GridFilterConfig } from "../filters";
import { GridVariant, IProductCardType } from "../models";
import {
    filterProducts,
    getActiveSorter,
    selectFilters,
    selectProducts,
    selectSortMethod,
} from "../selectors";
import { GridSorterConfig } from "../sorters";
import { ProductCard } from "./ProductCard";

import styles from "./GridContent.module.scss";

interface IProps {
    gridVariant: GridVariant;
    cardType: IProductCardType;
    filters: GridFilterConfig[];
    sorters?: GridSorterConfig[];
    disableHoverOverlay?: boolean;
    buildExternalCallout?: (rootProduct: IProduct) => React.ReactNode;
}

export const GridContent = (props: IProps): React.ReactNode => {
    const allProducts = useAppSelector(selectProducts);
    const filterValues = useAppSelector(selectFilters);
    const sortMethod = useAppSelector(selectSortMethod);

    const products = filterProducts(props.filters, allProducts, filterValues);
    const sorter = getActiveSorter(props.sorters, sortMethod);
    const sortedProducts = sorter.sort(products);

    console.table(sortedProducts.map((p) => ({ title: p.title })));

    return (
        <MasonryGrid
            className={styles.container}
            itemSelector={".product-grid-card"}
            entities={sortedProducts}
            getTileID={(product) => `${product.id}`}
            buildTile={(product, ref) => (
                <ProductCard
                    forwardedRef={ref}
                    key={`${product.id}`}
                    gridVariant={props.gridVariant}
                    cardType={props.cardType}
                    rootProduct={product}
                    disableHoverOverlay={props.disableHoverOverlay}
                    buildExternalCallout={props.buildExternalCallout}
                />
            )}
            emptyState={
                <div>
                    <p className={styles.emptyMessageHeading}>
                        {t`WE CAN'T FIND A PRODUCT THAT MATCHES YOUR SEARCH.`}
                    </p>
                    <p className={styles.emptyMessageBody}>
                        {t`Sorry about that! Please try your search again with another set of filters.`}
                    </p>
                </div>
            }
            options={{
                horizontalOrder: true,
                gutter: 0,
            }}
            forceEqualHeight={true}
        />
    );
};
